// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"2edbaf83","274":"bd889aa5","284":"6bf2a543","369":"1b835714","604":"a047ed27","657":"07976e6c","787":"78140b36","887":"68428fb7","972":"23391ebb"}[chunkId] + ".chunk.js";
};